export const expectedCancellation = (error: any) =>
  ['aborted', 'cancelled', 'auth/cancelled-popup-request'].includes(error?.code) ||
  /aborted|cancelled/i.test(error?.message || '');
